module.exports = __webpack_public_path__ + "img/bridgewater-logo.7859cd58.jpg";